import makeRequest from "./makeRequest";

import type { AxiosRequestConfig } from "axios";

interface RequestConfig<TData> extends AxiosRequestConfig<TData> {
    body?: any;
    fullResponse?: boolean; // 👈 новое
    isPublic?: boolean;
}

/**
 * Orval будет вызывать мутатор примерно как:
 * customMutator(requestConfig, externalOptions?)
 *
 * Первый аргумент — стандартный request конфиг (method, url, params, data, headers...)
 * Второй аргумент — дополнительные options, которые генерируются Orval (в нашем случае это тот самый per-call axios config)
 */
export const orvalMutator = <TData = unknown, TVariables = unknown>(
    config: AxiosRequestConfig<TVariables>,
    externalOptions?: RequestConfig<TVariables>,
): Promise<TData> => {
    const { method = "GET", url = "", data, headers, ...rest } = config;

    const isMultipart = typeof FormData !== "undefined" && data instanceof FormData;

    // Слияние: externalOptions должен иметь приоритет (если ты так хочешь),
    // либо наоборот — в зависимости от логики makeRequest.
    const merged = {
        ...rest,
        headers: { ...(headers || {}), ...(externalOptions?.headers || {}) },
        ...(externalOptions || {}),
        data,
    };
    // Пробрасываем merged в makeRequest (пример под твою реализацию)
    return makeRequest(
        method as any,
        url,
        { body: data, ...merged },
        isMultipart,
        false,
    ) as Promise<TData>;
};
